import Vue from 'vue';
import Router from 'vue-router';
// import { getToken, removeToken, removeLoginName, removeNextTimeRouter } from '@/utils/auth';
// import { Notify } from "vant";


Vue.use(Router);

const routes = [{
    path: '*',
    redirect: '/login'
},
{
    path: '/login',
    component: () => import('../view/layout/Layout'),
    children: [{
        name: 'login',
        path: '/login',
        component: () => import('../view/CloudFilm/Login'),
        meta: {
            keepAlive: true,
        }
    },
    {
        name: 'reportView',
        path: '/reportView',
        component: () => import('../view/CloudFilm/ReportView'),
        meta: {
            keepAlive: true,
        }
    },
    {
        name: 'thirdvistindex',
        path: '/thirdvistindex',
        component: () => import('../view/CloudFilm/ThirdVistView'),
        meta: {
            keepAlive: true,
        }
    },
    {
        name: 'PayInfo',
        path: '/PayInfo',
        component: () => import('../view/CloudFilm/PayInfo')
    },
    {
        name: 'ReportListView',
        path: '/ReportListView',
        component: () => import('../view/CloudFilm/ReportListView')
    },
    {
        name: 'me',
        path: '/Me',
        component: () => import('../view/CloudFilm/Me/Me')
    },
    ]
},
{
    name: 'imageVideoView',
    path: '/imageVideoView',
    component: () => import('../view/CloudFilm/ImageVideoView')
},
{
    name: 'DicomView_copy',
    path: '/DicomView_copy',
    component: () => import('../view/CloudFilm/DicomView_copy.vue')
},
{
    name: 'thirdDicomView',
    path: '/thirdDicomView',
    component: () => import('../view/CloudFilm/ThirdDicomView')
},
{
    name: 'filmImageView',
    path: '/filmImageView',
    component: () => import('../view/CloudFilm/FilmImageView')
},
{
    name: 'UserAgreement',
    path: '/UserAgreement',
    component: () => import('../view/CloudFilm/UserAgreement')
},
{
    name: 'ReportPdfView',
    path: '/ReportPdfView',
    component: () => import('../view/CloudFilm/ReportPdfView')
},

{
    name: 'userAgreement',
    path: '/userAgreement',
    component: () => import('../view/CloudFilm/UserAgreement.vue')
},
{
    name: 'myOrder',
    path: '/MyOrder',
    component: () => import('../view/CloudFilm/Me/MyOrder.vue')
},
{
    name: 'billingInfo',
    path: '/BillingInfo',
    component: () => import('../view/CloudFilm/Me/BillingInfo.vue')
},
{
    name: 'DicomView_abandon',
    path: '/DicomView_abandon',
    component: () => import('../view/CloudFilm/DigitalImage/DicomView_abandon.vue')
},
{
    name: 'DicomView',
    path: '/DicomView',
    props: true,
    component: () => import('../view/CloudFilm/DigitalImage/DicomView.vue')
},
{
    name: 'termsService',
    path: '/termsService',
    props: true,
    component: () => import('../view/CloudFilm/TermsService/index.vue')
}
];

// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});
const whiteList = ['/login', '/termsService', '/reportView', '/PayInfo', '/dicomView', '/imageCover', 'imageView','/thirdvistindex'] // no redirect whitelist
import { GetIsLogin } from '../utils/cacheUtils'
const router = new Router({ routes: routes });
router.beforeEach((to, from, next) => {
    // const hasToken = getToken()
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }

    if (whiteList.indexOf(to.path) !== -1 || GetIsLogin()) { // 白名单不拦截
        // in the free login whitelist, go directly
        next()
    } else { //跳转至登录界面
        window.localStorage.clear()
        next(`/login?redirect=${to.path}`)
    }
});

export {
    router
};